import React, { useState } from 'react';
import { Linking, ScrollView, Text, View } from 'react-native';

import { useNavigation } from '@react-navigation/native';
import Header from '../../components/Header/Header';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import DropDownMenu from '../Home/components/DropDownMenu/DropDownMenu';
import SupportDesc from './components/SupportDesc/SupportDesc';
import { styles } from './styles';
import { getAnalytics, logEvent } from '@react-native-firebase/analytics';

const Support = () => {
  const { goBack } = useNavigation();

  const [activeTab, setActiveTab] = useState('');

  const toggleTab = (tab: string) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
    } else {
      setActiveTab('');
    }
  };

  const analyticsInstance = getAnalytics();

  return (
    <ScrollView style={styles.scroll}>
      <Header />
      <View style={styles.containerHeader}>
        <SearchHeader onPress={goBack} title="Dúvidas Frequentes" mb={10} />
      </View>
      <View style={styles.containerDrop}>
        <DropDownMenu
          title="App"
          onPress={() => {
            logEvent(analyticsInstance, 'faq_app_click', {
              client_code: 'user?.clientCode',
            });
            toggleTab('App')
          }}
          isOpen={'App' === activeTab}
        />
        <DropDownMenu
          title="Pedidos"
          onPress={() => {
            logEvent(analyticsInstance, 'faq_order_click', {
              client_code: 'user?.clientCode',
            }); toggleTab('Pedidos')
          }}
          isOpen={'Pedidos' === activeTab}
        />
        <DropDownMenu
          title="Entregas"
          onPress={() => {
            logEvent(analyticsInstance, 'faq_delivery_click', {
              client_code: 'user?.clientCode',
            }); toggleTab('Entregas')
          }}
          isOpen={'Entregas' === activeTab}
        />
        <DropDownMenu
          title="Cadastro"
          onPress={() => {
            logEvent(analyticsInstance, 'faq_register_click', {
              client_code: 'user?.clientCode',
            }); toggleTab('Cadastro')
          }}
          isOpen={'Cadastro' === activeTab}
        />
      </View>
      <View style={styles.content}>
        {activeTab === 'App' && (
          <>
            <SupportDesc
              title="Como posso alterar minha senha?"
              description='Você pode acessar o menu "Config. de Conta", na aba "Alterar senha". Lá
        você deverá informar a senha atual, uma nova senha e confirmar a nova
        senha.'
            />
            <SupportDesc
              title="Como posso ver as campanhas em que estou participando?"
              description="Assim que você entrar no App, já estará disponível na tela
              principal todas as campanhas ativas para o seu perfil."
            />
            <SupportDesc
              title="Existe uma maneira de desativar as notificações?"
              description="Sim! Você pode acessar o menu “Config. de Conta”. Clique na opção
              “Notificações” e informe que não deseja mais recebe-las."
            />
            <SupportDesc
              title="Esqueci minha senha e não tenho mais acesso ao e-mail
                cadastrado. O que devo fazer?"
              description="Para realizar a recuperação de senha é necessário que se tenha um
              e-mail válido. Nesse caso, entre em contato no 0800 061 5000 e
              solicite a atualização do seu e-mail. OBS: será necessário que
              você responda algumas perguntas ao operador para fins de
              segurança."
            />
          </>
        )}
        {activeTab === 'Pedidos' && (
          <>
            <SupportDesc
              title="O vendedor não passou hoje, ou a minha loja estava fechada no
                momento. Vou ficar sem pedido?"
              description="Você pode realizar seu pedido pelo canal de atendimento do
              WhatsApp pelo número 61 98411-0333, onde você poderá fazer seus
              pedidos até às 15:30hs. Ao realizar o pedido nesse canal,
              enviaremos seus produtos no dia correto da entrega. Caso seja o
              seu primeiro acesso, algumas perguntas serão feitas pelo nosso
              chatbot para confirmar o seu cadastro. Com isso seus próximos
              acessos serão bem rápidos e práticos! Nem todos os produtos que
              pedi ao vendedor foram entregues e nem constam na nota fiscal. O
              que devo fazer? A Brasal trabalha incansavelmente para atender a
              100% da demanda dos nossos clientes. Contudo, é possível que
              eventualmente não haja estoque suficiente para suprir toda a
              demanda. É importante que, ao receber o seu pedido, os produtos
              entregues estejam em conformidade com a descrição da nota fiscal.
              Nesse caso, não se preocupe! Os itens faltantes não serão
              cobrados."
            />
            <SupportDesc
              title="Como posso aumentar o meu limite de compra?"
              description="Procure o seu vendedor e faça a solicitação. Será necessário
              compartilhar 3 referências de outros fornecedores com o limite
              desejado. A análise será realizada pelo departamento financeiro e
              o vendedor dará retorno se a solicitação foi aprovada ou não."
            />
            <SupportDesc
              title="Como posso aumentar o meu prazo de pagamento?"
              description="Procure o seu vendedor e faça a solicitação. Será necessário
              compartilhar 3 referências de outros fornecedores com o prazo
              desejado. A análise será realizada pelo departamento financeiro e
              o vendedor dará retorno se a solicitação foi aprovada ou não."
            />
            <SupportDesc
              title="Não gostei de uma atitude do vendedor. Como posso reportar isso?"
              description="Nós prezamos pelo excelente atendimento aos nossos clientes. Caso
              se sinta desconfortável com alguma situação, por favor entre em
              contato no 0800 061 5000 e faça uma reclamação. O fato será
              apurado e tomadas as providências necessárias."
            />
          </>
        )}
        {activeTab === 'Entregas' && (
          <>
            <SupportDesc
              title="O meu pedido chegou incompleto. O produto consta na nota fiscal,
                mas não está sendo entregue fisicamente. O que fazer?"
              description="Os produtos que você receber fisicamente precisam estar 100% de
              acordo com as quantidades descritas na nota fiscal. Caso haja
              alguma diferença, registre os itens e quantidades no campo de
              observações do canhoto da nota fiscal e comunique ao motorista,
              pois a Brasal fará a reposição do item faltante na próxima
              entrega. É importante que a conferência seja feita no momento da
              entrega, pois não há procedimento de reposição após a conclusão do
              recebimento. Contudo, você tem todo o direito de não receber o
              pedido caso essa diferença exista. Nesse caso, sua próxima entrega
              será realizada no dia correto da rota."
            />
            <SupportDesc
              title="Gostaria de alterar o meu dia de entrega. Como posso fazer isso?"
              description="Os dias de entrega definidos para cada cliente são planejados de
              forma que a nossa operação esteja apta a atender a todas as
              demandas de entrega. Nesse caso, é importante que você se mantenha
              no dia indicado para não acarretar em atrasos ou não atendimento
              aos demais clientes."
            />
            <SupportDesc
              title="O meu pedido não chegou no dia combinado. O que devo fazer?"
              description="Tenha o seu CNPJ ou código de cliente em mãos e entre em contato
              com o departamento logístico da Brasal Refrigerantes para obter
              informações. Se o seu estabelecimento está situado no DF, entre em
              contato pelo número 61 3356-9816. Para estabelecimentos situados
              em outras localidades, o contato se dá pelo número 0800 061 5000."
            />
            <SupportDesc
              title="Não gostei de uma atitude do motorista. Como posso reportar
                isso?"
              description="Nós prezamos pelo excelente atendimento aos nossos clientes. Caso
              se sinta desconfortável com alguma situação, por favor entre em
              contato no 0800 061 5000 e faça uma reclamação. O fato será
              apurado e tomadas as providências necessárias."
            />
          </>
        )}
        {activeTab === 'Cadastro' && (
          <>
            <SupportDesc
              title="Estou com um problema na SEFAZ. Ainda posso comprar com a
                Brasal?"
              description="A sua situação precisa estar regularizada junto à SEFAZ para que a
              Brasal consiga emitir nota fiscal. Toda nota fiscal é emitida
              eletronicamente e passa pela validação da SEFAZ, que rejeita a
              emissão da nota fiscal sempre que houver alguma irregularidade.
              Por esse motivo, não será possível concluir a sua compra."
            />
            <SupportDesc
              title="Vou mudar o meu CNPJ ou alguma informação cadastral e preciso
                alterar. Como posso fazer isso?"
              description="Procure o seu vendedor e solicite a alteração, ou, se preferir,
              entre em contato com o nosso Serviço de Atendimento ao Revendedor
              por meio do número 0800 061 5000. Algumas documentações poderão
              ser solicitadas para efetivar a alteração."
            />
          </>
        )}
      </View>
      <Text style={styles.anyQuest}>Você ainda tem uma pergunta?</Text>
      <Text style={styles.contact}>
        Seu você não encontrou a sua pergunta, entre em contato com o nosso
        0800!
      </Text>
      <Text style={styles.phone} onPress={() => Linking.openURL('tel:08000615000')}>0800 061 5000</Text>
      <Text style={styles.service}>Serviço de Atendimento ao Revendedor</Text>
    </ScrollView>
  );
};

export default Support;
